import React, { FC } from "react";
import { Box, SxProps } from "@mui/material";
import { useSxMerge } from "shared-ts-mui";

const logoUrlStandard =
  "https://airmontstorage.blob.core.windows.net/public-images/airmont_logo.svg";
const logoUrlSmallStandard =
  "https://airmontstorage.blob.core.windows.net/public-images/aM.svg";

const logoUrlSecondary =
  "https://airmontstorage.blob.core.windows.net/public-images/airmont_logo_orange.svg";
const logoUrlSmallSecondary =
  "https://airmontstorage.blob.core.windows.net/public-images/aM_orange.svg";

export interface AirmontLogoImgProps {
  size?: "standard" | "small";
  title?: string;
  variant?: "primary" | "secondary";
  sx?: SxProps;
}
export const AirmontLogoImg: FC<AirmontLogoImgProps> = (props) => {
  const primary = (props.variant ?? "primary") === "primary";
  const largeLogoUrl = primary ? logoUrlStandard : logoUrlSecondary;
  const smallLogoUrl = primary ? logoUrlSmallStandard : logoUrlSmallSecondary;
  const size = props.size ?? "standard";
  const logoUrl = size === "standard" ? largeLogoUrl : smallLogoUrl;
  //const { t } = useTranslation("my-chimney-ts-translations");

  const sx = useSxMerge(
    {
      width: "auto",
      maxHeight: "62px",
    },
    props.sx
  );

  return (
    <Box
      component={"img"}
      src={logoUrl}
      alt={props.title}
      title={props.title}
      sx={sx}
    />
  );
};
